import React from 'react';
import { FormattedMessage } from 'react-intl';

export const NAME_TEXT = {
    id: 'oe.newtelephone.name',
    defaultMessage: 'Name',
    description: 'Label text',
};

export const PROVIDER_TEXT = {
    id: `oe.telephone.provider`,
    defaultMessage: 'Provider',
    description: 'Label text',
};

export const ONE_TAP_FORMULA_TEXT = {
    id: `oe.telephone.oneTapFormula`,
    defaultMessage: 'One-Tap Formula',
    description: 'Label text',
};

export const FILE_ARCHIVE_TEXT = {
    id: 'oe.telephone.TelephoneArchive',
    description: 'Placeholder text',
    defaultMessage: 'Number Set CSV',
};

export const telephoneDataIsBeingSavedText = (): React.ReactElement => (
    <FormattedMessage
        id="oe.telephone.numberSetIsBeingSaved"
        description="Placeholder about saving theme"
        defaultMessage="Telephone number set is being saved, please wait..."
    />
);

export const NEW_NUMBER_SET_NOTIFICATION_TEXT = {
    id: 'oe.telephone.telephoneNumberSetAdded',
    description: 'Notification about added telephone nuber set',
    defaultMessage: 'New Telephone number set added',
};

export const TELEPHONE_ARCHIVE_ERROR_TEXT = {
    id: 'oe.telephone.telephoneArchiveIsRequired',
    defaultMessage: 'CSV file required',
    description: 'Error message in telephone number set popover'
};

export const UPDATE_NUMBER_SET_NOTIFICATION_TEXT = {
    id: 'oe.telephone.telephoneNumberSetUpdated',
    description: 'Notification about update telephone nuber set',
    defaultMessage: 'Updated Telephone Number Set',
};

export const DOWNLOAD_NUMBER_SET = {
    id: 'oe.csv.downloadNumberSet',
    defaultMessage: 'Download Number Set',
    description: 'Label text'
};

export const EDIT_NUMBER_SET_TEXT = {
    id: 'oe.telephone.editNumberSet',
    defaultMessage: 'Edit Number Set',
    description: 'Button text',
};

export const DEACTIVATE_NUMBER_SET_TEXT = {
    id: 'oe.telephone.inactivateNumberSet',
    defaultMessage: 'Deactivate Number Set',
    description: 'Button text',
};

export const ALERT_TEXT = {
    id: 'oe.alerts.areYouSure',
    description: 'Alert message',
    message: 'Are you sure you want to'
};

export const ALERT_TEXT_DANGER = {
    id: 'oe.meeting.inactivateNumberSet',
    message: 'Deactivate this Number Set',
    description: 'Label text'
};

export const ALERT_TEXT_DESCRIPTION = {
    id: 'oe.alerts.inactiateDescription',
    message: 'It will no longer be available in the Number Set list or available for selection when adding number sets to meetings',
    description: 'Label text',
};
